module.exports = __webpack_public_path__ + "static/media/Cats eyes 09_SVENSKA-mixdown.b17c06fd.mp3";